import moment from "moment";

export function formatTimeTaken(rowObj: any) {
  if (rowObj.statusUpdatedAt == null || rowObj.depositedAt == null) {
    return "-";
  }
  const diff = moment(rowObj.statusUpdatedAt).diff(rowObj.depositedAt);
  const hours =
    moment.duration(diff).days() * 24 + moment.duration(diff).hours();
  if (hours < 24) {
    return moment.utc(diff).format("HH:mm:ss");
  }
  return hours + ":" + moment.utc(diff).format("mm:ss");
}

export function formatTimeStarted(rowObj: any) {
  if (rowObj.depositedAt == null) {
    return "-";
  }
  const date = new Date(rowObj.depositedAt);
  // const formatDate = moment.utc(date).local().format('ddd MMM DD YYYY h:mm A')
  const formatDate = moment(date).format("DD MMMM yyyy HH:mm:ss");

  return formatDate;
}

export function formatStatusDate(rowObj: any) {
  if (rowObj.statusUpdatedAt == null) {
    return "-";
  }
  const date = new Date(rowObj.statusUpdatedAt);
  const formatDate = moment(date).format("DD MMMM yyyy HH:mm:ss");
  return formatDate;
}

export function formatExceptionDate(rowObj: any) {
  if (rowObj.exceptionCreatedAt == null) {
    return "-";
  }
  const date = new Date(rowObj.exceptionCreatedAt);
  const formatDate = moment(date).format("DD MMMM yyyy HH:mm:ss");
  return formatDate;
}
